// extracted by mini-css-extract-plugin
module.exports = {"releaseNotes":"style_releaseNotes__SPhXE","notify":"style_notify__-f2ao"};